import React, { createContext, useContext, useState } from "react";
import pinsData from "./pages/pins.json";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    sessionStorage.getItem("isAuthorized") === "true",
  );

  const login = (inputPin) => {
    const now = new Date();
    const currentMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;

    const validPin = pinsData.find(
      (p) => p.code === inputPin && p.date === currentMonth,
    );

    if (validPin) {
      sessionStorage.setItem("isAuthorized", "true");
      setIsAuthenticated(true);
      return { success: true };
    } else {
      return {
        success: false,
        message: "Буруу код байна!",
      };
    }
  };

  const logout = () => {
    sessionStorage.removeItem("isAuthorized");
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
